module.exports = __webpack_public_path__ + "static/media/info.a76e3652.svg";